<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row">

                <div class="mb-3">
                    <h2>Our Courses</h2>
                </div>

                <!-- New Course Listings -->
                <div class="col-sm-12 py-3 px-0">
                    <h6><strong><span class="course-item"><router-link to="/ei" class="course-link">具身智能引论 (2026春季)</router-link></span> <i class="fa fa-link link-icon"></i></strong></h6>
                    <p class="course-description">本课程围绕具身人工智能这一新兴人工智能领域的核心理念和教学目标进行构建，着重培养学生对具身智能的基本原理、机器学习与大模型技术、软硬件系统集成方法的深入理解和实际应用能力，包括理解具身人工智能的原理和挑战，学习设计和实施使自主决策和物理交互成为可能的基于大模型的智能算法，开发基于大模型技术的集成传感器与执行器的智能交互系统的技能，通过设计实现与环境和人交互的具身智能系统原型获得实践经验。</p>
                </div>
                <!-- 课程标题 -->

                <div class="col-sm-12 py-3 px-0">
                    <h6><strong><span class="course-item"><router-link to="/ML_Sys" class="course-link">Machine Learning Systems</router-link></span> <i class="fa fa-link link-icon"></i></strong></h6>
                    <p class="course-description">The Machine Learning Systems (ML Sys) course focuses on the integration of algorithms, system software, and hardware to build efficient and scalable machine learning services. It covers topics such as the evolution of machine learning architectures, including GPUs and specialized AI accelerators, and explores optimization techniques like CUDA programming, parallel training, efficient inference, and model optimization. The course delves into the practical challenges of large-scale neural network development, training and inference, emphasizing the importance of a holistic view of communication-storage-computing optimization and parallelism. Ethical considerations, including privacy, safety, and sustainability, are also addressed. Through hands-on programming and project work, students gain a real-world understanding of ML systems, from design to deployment, and learn to create machine learning systems that are efficient, scalable, and reliable for the fast-evolving and diverse AI applications.</p>
                </div>
                <div class="col-sm-12 py-3 px-0">
                    <h6><strong><span class="course-item"><router-link to="/ML_Sys_seminar" class="course-link">Machine Learning Systems Seminar Series</router-link></span> <i class="fa fa-link link-icon"></i></strong></h6>
                    <p class="course-description">In collaboration with the Machine Learning Systems (ML Sys) course, we are organizing a Machine Learning Systems Seminar Series.  The goal of this seminar series is to help students shift from an academic model-centric mindset to one that embraces real-world system development and deployment. To support this transformation, we invite industry experts to deliver talks on topics aligned with the course content, including (but not limited to): ML compilers and optimizations, parallel training, inference systems, deployment on mobile and edge devices, hardware accelerators, and open-source community practices.</p>
                    
                </div>

                <div class="col-sm-12 py-3 px-0">
                    <h6><strong><span class="course-item">Human Computer Interaction (Spring 2025)</span></strong></h6>
                    <p class="course-description">The Human-Computer Interaction (HCI) course provides an in-depth exploration of the latest technologies in the field, covering a broad spectrum of interaction methods including gesture-based interfaces, visual interaction, conversational AI, brain-computer interfaces, and humanoid robots. Students will gain hands-on experience with these emerging technologies and understand how they are transforming the way humans interact with computers. The course also includes a practical project where students will design and develop a prototype for an intelligent HCI system, giving them the opportunity to apply their knowledge and creativity in building innovative solutions that enhance user experiences through intuitive interfaces.</p>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style scoped>
.course-link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
}

.course-link:hover {
    text-decoration: underline;
}

/* General course item with dot before it */
.course-item::before {
    content: "• ";
    color: #032244;  /* Change the dot color as needed */
    margin-right: 10px;
}

/* Indent the course description by two spaces (0.5em each) */
.course-description {
    padding-left: 1em;  /* Indent by 1em to simulate two spaces */
    color: #032244;     /* Darken the text color */
}

/* Link icon styling */
.link-icon {
    font-size: 1em;
    color: #032244;
    margin-left: 5px;
}
</style>